import { CXAssessmentBase } from '@/components/cx/CXAssessmentBase';
import { getScenarioByCompany } from '@/config/cx-scenarios';
import { useParams, Navigate } from 'react-router-dom';

export function CXAssessmentWrapper() {
  const { companyCode } = useParams<{ companyCode: string }>();

  if (!companyCode) {
    return <Navigate to="/404" replace />;
  }

  const scenario = getScenarioByCompany(companyCode);

  if (!scenario) {
    // If scenario doesn't exist, show 404
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Company not found
          </h1>
          <p className="text-gray-600">
            No assessment scenario found for company: {companyCode}
          </p>
        </div>
      </div>
    );
  }

  // Use scenario code (which is same as companyCode for now) for API paths
  const scenarioCode = companyCode;

  return (
    <CXAssessmentBase
      scenario={scenario}
      apiBasePath={`api/cx/scenarios/${scenarioCode}`}
      roleplayPath={`/cx/${scenarioCode}/roleplay`}
    />
  );
}